/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { useQuery } from 'react-query';
import type {
    InvalidateOptions,
    QueryClient,
    QueryFunction,
    QueryKey,
    UseQueryOptions,
    UseQueryResult,
} from 'react-query';

import { customFetchInstance } from '../../../../../../orval/client/custom-fetch';
import { getCustomQueryOptions } from '../../../../../../orval/mutator/custom-query-options';
import type {
    ApiModulesDropdownListParams,
    ApiModulesListParams,
    ModuleDropdown,
    ModuleList,
} from '../../models';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K,
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key !== 'queryKey') {
            Object.defineProperty(result, key, {
                enumerable: true,
                configurable: true,
                get: () => (query as Record<string, unknown>)[key],
            });
        }
    }
    return result;
};

export const getApiModulesListUrl = (params?: ApiModulesListParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(
                key,
                value === null ? 'null' : String(value),
            );
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `${process.env.ORVAL_API_BASE_URL}/api/modules/?${stringifiedParams}`
        : `${process.env.ORVAL_API_BASE_URL}/api/modules/`;
};

export const apiModulesList = async (
    params?: ApiModulesListParams,
    options?: RequestInit,
): Promise<ModuleList[]> => {
    return customFetchInstance<ModuleList[]>(getApiModulesListUrl(params), {
        credentials: 'same-origin',
        ...options,
        method: 'GET',
    });
};

export const getApiModulesListQueryKey = (params?: ApiModulesListParams) => {
    return ['apiModulesList', ...(params ? [params] : [])] as const;
};

export const useApiModulesListQueryOptions = <
    TData = Awaited<ReturnType<typeof apiModulesList>>,
    TError = unknown,
>(
    params?: ApiModulesListParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiModulesList>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getApiModulesListQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof apiModulesList>>
    > = ({ signal }) => apiModulesList(params, { signal, ...requestOptions });

    const customOptions = getCustomQueryOptions({
        queryKey,
        queryFn,
        ...queryOptions,
    });

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<typeof apiModulesList>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type ApiModulesListQueryResult = NonNullable<
    Awaited<ReturnType<typeof apiModulesList>>
>;
export type ApiModulesListQueryError = unknown;

export function useApiModulesList<
    TData = Awaited<ReturnType<typeof apiModulesList>>,
    TError = unknown,
>(
    params?: ApiModulesListParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiModulesList>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useApiModulesListQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const invalidateApiModulesList = async (
    queryClient: QueryClient,
    params?: ApiModulesListParams,
    options?: InvalidateOptions,
): Promise<QueryClient> => {
    await queryClient.invalidateQueries(
        {
            queryKey: getCustomQueryOptions({
                queryKey: getApiModulesListQueryKey(params),
            }).queryKey,
        },
        options,
    );

    return queryClient;
};

export const getApiModulesDropdownListUrl = (
    params?: ApiModulesDropdownListParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(
                key,
                value === null ? 'null' : String(value),
            );
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `${process.env.ORVAL_API_BASE_URL}/api/modules/dropdown/?${stringifiedParams}`
        : `${process.env.ORVAL_API_BASE_URL}/api/modules/dropdown/`;
};

export const apiModulesDropdownList = async (
    params?: ApiModulesDropdownListParams,
    options?: RequestInit,
): Promise<ModuleDropdown[]> => {
    return customFetchInstance<ModuleDropdown[]>(
        getApiModulesDropdownListUrl(params),
        {
            credentials: 'same-origin',
            ...options,
            method: 'GET',
        },
    );
};

export const getApiModulesDropdownListQueryKey = (
    params?: ApiModulesDropdownListParams,
) => {
    return ['apiModulesDropdownList', ...(params ? [params] : [])] as const;
};

export const useApiModulesDropdownListQueryOptions = <
    TData = Awaited<ReturnType<typeof apiModulesDropdownList>>,
    TError = unknown,
>(
    params?: ApiModulesDropdownListParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiModulesDropdownList>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getApiModulesDropdownListQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof apiModulesDropdownList>>
    > = ({ signal }) =>
        apiModulesDropdownList(params, { signal, ...requestOptions });

    const customOptions = getCustomQueryOptions({
        queryKey,
        queryFn,
        ...queryOptions,
    });

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<typeof apiModulesDropdownList>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type ApiModulesDropdownListQueryResult = NonNullable<
    Awaited<ReturnType<typeof apiModulesDropdownList>>
>;
export type ApiModulesDropdownListQueryError = unknown;

export function useApiModulesDropdownList<
    TData = Awaited<ReturnType<typeof apiModulesDropdownList>>,
    TError = unknown,
>(
    params?: ApiModulesDropdownListParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiModulesDropdownList>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useApiModulesDropdownListQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const invalidateApiModulesDropdownList = async (
    queryClient: QueryClient,
    params?: ApiModulesDropdownListParams,
    options?: InvalidateOptions,
): Promise<QueryClient> => {
    await queryClient.invalidateQueries(
        {
            queryKey: getCustomQueryOptions({
                queryKey: getApiModulesDropdownListQueryKey(params),
            }).queryKey,
        },
        options,
    );

    return queryClient;
};
